module.exports = __webpack_public_path__ + "img/grey_043.c3faec4f.png";